// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orderAggsContainer {
  padding-top: 64px;
  padding-left: 8px;
  padding-right: 8px;
  width: 100%;
  box-sizing: border-box;
  height: 100vh;
  /* margin-bottom: 70px; */
}

.orderAggsHeader {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: space-between;
  padding-right: 4px;
}

.aggTabsContainer {
  display: flex;
  align-items: center;
  background-color: #fdfefe;
  padding: 4px 4px;
  border-radius: 50px;
  font-size: 0.813rem;
  font-weight: 500;
  gap: 2px;
  width: max-content;
  box-shadow:
    0 -1px 3px rgba(0, 0, 0, 0.04),
    /* top shadow */ 0 -1px 2px rgba(0, 0, 0, 0.02),
    /* soft top */ 0 1px 3px rgba(0, 0, 0, 0.04),
    /* bottom shadow */ 0 1px 2px rgba(0, 0, 0, 0.02);
  /* soft bottom */
}

.orderAggsHeaderRightContainer {
  display: flex;
  align-items: center;
  gap: 12px;
}

.orderAggsHeader--kds {
  flex-wrap: nowrap;
  min-width: 0;
}

.orderAggsHeader--kds > .aggTabsContainer,
.orderAggsHeader--kds > .kds-tabs-navigation,
.orderAggsHeaderRightContainer--kds > .prepstation-filter-wrapper,
.orderAggsHeaderRightContainer--kds > .source-filter-wrapper {
  flex-shrink: 0;
}

.orderAggsHeaderRightContainer--kds {
  flex: 1 1 0;
  min-width: 0;
  gap: 6px;
}

.kds-tabs-navigation {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.kds-tabs-clip {
  overflow: hidden;
  flex: 0 0 auto;
  transition: width 200ms ease;
}

.kds-tabs-content {
  width: max-content;
  padding: 2px;
}

.kds-tabs-content .aggsTabsInnerContainer {
  white-space: nowrap;
}

.kds-tabs-content .aggsTabsInnerContainer[hidden] {
  display: none;
}

.kds-tabs-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #dce4e9;
  border-radius: 50%;
  background: #fff;
  color: #3f556b;
  cursor: pointer;
}

.kds-tabs-toggle:hover {
  background: #f1f5f9;
}

.kds-tabs-toggle:focus-visible {
  outline: 2px solid #2a71ff;
  outline-offset: 2px;
}

.kds-tabs-toggle svg {
  transition: transform 200ms ease;
}

.kds-tabs-navigation.is-collapsed .kds-tabs-toggle svg {
  transform: rotate(180deg);
}

.dark .kds-tabs-toggle {
  background: #1e293b;
  color: #cbd5e1;
  border-color: #475569;
}

.dark .kds-tabs-toggle:hover {
  background: #334155;
}

@media (prefers-reduced-motion: reduce) {
  .kds-tabs-clip,
  .kds-tabs-toggle svg {
    transition: none;
  }
}

@media (max-width: 900px) {
  .orderAggsHeader--kds {
    flex-wrap: wrap;
  }
  .orderAggsHeaderRightContainer--kds {
    flex-basis: 100%;
  }
  .orderAggsHeader--kds.orderAggsHeader--tabs-collapsed {
    flex-wrap: nowrap;
  }
  .orderAggsHeader--tabs-collapsed .orderAggsHeaderRightContainer--kds {
    flex-basis: 0;
  }
}

.aggsTabsInnerContainer {
  padding: 6px 12px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #3f556b;
}

.tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.aggsTabsInnerContainer:hover {
  background-color: var(--surface-g2);
  color: var(--surface-black);
  cursor: pointer;
}

.aggsTabsInnerContainer.active {
  background-color: var(--surface-black);
  color: var(--surface-white);
}

.orderAggsActiveTab {
  margin-top: 8px;
}

.board-status-refresh-container {
  background-color: #ffffff;
  padding: 3px 2px;
  border-radius: 12px;
  box-shadow:
    0 -1px 3px rgba(0, 0, 0, 0.04),
    /* top shadow */ 0 -1px 2px rgba(0, 0, 0, 0.02),
    /* soft top */ 0 1px 3px rgba(0, 0, 0, 0.04),
    /* bottom shadow */ 0 1px 2px rgba(0, 0, 0, 0.02);
  /* soft bottom */
}

.board-status-refresh-container:hover {
  cursor: pointer;
}

.textAlignCorrection {
  padding-top: 1px;
}

.pause-orders-btn-wrapper {
  position: relative;
  display: inline-flex;
}

.pause-orders-count-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9999px;
  background-color: #da4343;
  color: #ffffff;
  font-size: 0.65rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 2px #ffffff;
}

/* Pause Orders Drawer Modal Styles */
.pause-orders-drawer {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  font-family: inherit;
}

/* Drawer Header */
.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
  padding: 20px 24px;
}

.drawer-title {
  font-size: 1.25rem;
  /* text-xl */
  font-weight: 600;
  /* font-semibold */
  letter-spacing: -0.025em;
  /* tracking-tight */
  color: #0f172a;
  /* text-slate-900 */
  margin: 0;
}

/* Close Button */
.drawer-close-btn {
  display: inline-flex;
  height: 40px;
  /* h-10 */
  width: 40px;
  /* w-10 */
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  /* rounded-full */
  border: 1px solid #e2e8f0;
  /* border-slate-200 */
  background-color: transparent;
  color: #64748b;
  /* text-slate-500 */
  cursor: pointer;
  transition: all 0.2s ease;
}

.drawer-close-btn:hover {
  border-color: #cbd5e1;
  /* border-slate-300 */
  background-color: #f8fafc;
  /* bg-slate-50 */
  color: #0f172a;
  /* text-slate-900 */
}

.drawer-close-btn svg {
  width: 16px;
  /* h-4 */
  height: 16px;
  /* w-4 */
}

/* Drawer Content */
.drawer-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

/* Banner: Pause All Channels */
.pause-all-banner {
  border-radius: 28px;
  border: 1px solid #ffedd5;
  /* border-orange-100 */
  background-color: rgba(254, 243, 199, 0.4);
  /* bg-orange-50/60 styled beautifully */
  padding: 16px;
  box-shadow: 0 12px 30px rgba(249, 115, 22, 0.08);
  margin-bottom: 20px;
}

.pause-all-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.pause-all-title {
  font-size: 0.875rem;
  /* text-sm */
  font-weight: 600;
  /* font-semibold */
  color: #0f172a;
  /* text-slate-900 */
  margin: 0;
}

.pause-all-subtitle {
  margin-top: 4px;
  font-size: 0.75rem;
  /* text-xs */
  color: #ea580c;
  /* text-orange-600 */
  margin-bottom: 0;
}

/* Toggle Switch Styles */
.drawer-toggle-switch {
  position: relative;
  display: inline-flex;
  height: 20px;
  /* h-5 */
  width: 36px;
  /* w-9 */
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px;
  /* rounded-full */
  border: 2px solid transparent;
  background-color: #cbd5e1;
  /* gray bg when unchecked */
  box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease;
  padding: 0;
  outline: none;
}

.drawer-toggle-switch[data-state="checked"] {
  background-color: #2a71ff;
  /* bg-[#2A71FF] */
}

.drawer-toggle-switch:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow:
    0 0 0 2px #ffffff,
    0 0 0 4px #2a71ff;
}

.drawer-toggle-switch:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.drawer-toggle-thumb {
  pointer-events: none;
  display: block;
  height: 16px;
  /* h-4 */
  width: 16px;
  /* w-4 */
  border-radius: 9999px;
  background-color: #ffffff;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(0);
}

.drawer-toggle-switch[data-state="checked"] .drawer-toggle-thumb {
  transform: translateX(16px);
  /* translate-x-4 */
}

.platform-waiting-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #ea580c;
    background-color: rgba(254, 243, 199, 0.4);
    border: 1.6px dotted #f97316;
    padding: 2px 10px;
    border-radius: 9999px;
    white-space: nowrap;
}

/* Platforms List Container */
.platforms-list-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* space-y-2 */
}

/* Platform Row */
.platform-row-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 16px;
  /* rounded-2xl */
  border: 1px solid rgba(226, 232, 240, 0.8);
  /* border-slate-200/80 */
  background-color: #ffffff;
  padding: 12px 16px;
  /* px-4 py-3 */
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.platform-info-flex {
  display: flex;
  align-items: center;
  gap: 12px;
  /* gap-3 */
}

/* Logo Box Container */
.platform-logo-box {
  display: flex;
  height: 36px;
  /* h-9 */
  width: 36px;
  /* w-9 */
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  /* rounded-xl */
  background-color: #f8fafc;
  /* bg-slate-50 */
  box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.7);
  /* ring-1 ring-inset ring-slate-200/70 */
}

/* Specific Platform Logo Badge Styles */
.platform-icon-letter {
  color: #ffffff;
  padding: 4px;
  border-radius: 6px;
  /* rounded-md */
  font-size: 10px;
  /* text-[10px] */
  font-weight: 700;
  /* font-bold */
  width: 24px;
  /* w-6 */
  height: 24px;
  /* h-6 */
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.platform-zomato {
  background-color: #dc2626;
  /* bg-red-600 */
}

.platform-swiggy {
  background-color: #f97316;
  /* bg-orange-500 */
}

.platform-ubereats {
  background-color: #16a34a;
  /* bg-green-600 */
}

.platform-svg {
  width: 24px;
  /* w-6 */
  height: 24px;
  /* h-6 */
}

.platform-website {
  color: #3b82f6;
  /* text-blue-500 */
}

.platform-whatsapp {
  color: #22c55e;
  /* text-green-500 */
}

.platform-magicpin {
  color: #64748b;
  /* text-slate-500 */
}

.platform-label {
  font-size: 15px;
  /* text-[15px] */
  font-weight: 600;
  /* font-semibold */
  color: #0f172a;
  /* text-slate-900 */
  cursor: pointer;
}

/* Drawer Sticky Footer */
.drawer-footer {
  position: sticky;
  bottom: 0;
  border-top: 1px solid #e2e8f0;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 16px 24px;
  /* px-6 py-4 */
  backdrop-filter: blur(8px);
  /* backdrop-blur-sm */
  z-index: 10;
}

.drawer-footer-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  /* gap-3 */
}

/* Cancel Button */
.drawer-btn-cancel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 0.875rem;
  /* text-sm */
  font-weight: 500;
  /* font-medium */
  transition: all 0.2s ease;
  border: 1px solid #e2e8f0;
  /* border-slate-200 */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border-radius: 9999px;
  /* rounded-full */
  height: 44px;
  /* h-11 */
  padding: 8px 20px;
  /* px-5 py-2 */
  color: #334155;
  /* text-slate-700 */
  background-color: #ffffff;
  cursor: pointer;
}

.drawer-btn-cancel:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

/* Save Button */
.drawer-btn-save {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 0.875rem;
  /* text-sm */
  font-weight: 500;
  /* font-medium */
  transition: all 0.2s ease;
  border: 1px solid #2a71ff;
  border-radius: 9999px;
  /* rounded-full */
  background-color: #2a71ff;
  /* bg-[#2A71FF] */
  padding: 8px 20px;
  /* px-5 py-2 */
  color: #ffffff;
  /* text-white */
  height: 44px;
  /* h-11 */
  cursor: pointer;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.drawer-btn-save:hover:not(:disabled) {
  background-color: #1f63e8;
  /* hover:bg-[#1F63E8] */
  border-color: #1f63e8;
}

.drawer-btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Custom Returns Filter Header Styles */
.returns-header-container {
  display: flex;
  min-width: 0;
  flex-shrink: 0;
  align-items: center;
  gap: 12px;
}

.returns-filters-wrapper {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 12px;
}

.returns-datepicker-wrapper {
  position: relative;
}

.returns-datepicker-wrapper .react-datepicker-wrapper {
  width: 166px;
}

.returns-datepicker-wrapper .react-datepicker__close-icon {
  right: 0px;
}

.returns-filter-date-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  outline: none;
  min-height: 36px;
  padding-top: 8px;
  padding-bottom: 8px;
  height: 44px;
  width: 174px;
  justify-content: space-between;
  border-radius: 22px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  padding-left: 16px;
  padding-right: 30px;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.returns-filter-date-btn:hover {
  border-color: #cbd5e1;
  background-color: #ffffff;
  cursor: pointer;
}

.returns-filter-date-btn:disabled {
  pointer-events: none;
  opacity: 0.5;
}

.returns-filter-date-btn-span {
  display: flex;
  align-items: center;
  gap: 12px;
}

.returns-select-container {
  position: relative;
  width: 170px;
  flex-shrink: 0;
}

.returns-select-container .returns-select-icon-left {
  z-index: 1;
}

.returns-select-container .soft-select__menu {
  right: 0;
  left: auto;
  min-width: 190px;
  z-index: 300 !important;
}

.returns-select-container .soft-select__control {
  height: 44px !important;
  border-radius: 22px !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  background-color: #ffffff !important;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
}

.returns-select-container .soft-select__control--is-focused {
  border-color: #cbd5e1 !important;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08) !important;
}

.returns-select-container .soft-select__value-container {
  padding-left: 44px !important;
  padding-right: 40px !important;
}

.returns-select-container .soft-select__single-value {
  color: #334155 !important;
}

.returns-select-container .soft-select-wrapper-I {
  border: none !important;
  margin-bottom: 0 !important;
}

.order-history-select-container {
  position: relative;
  width: 170px;
  flex-shrink: 0;
}

.order-history-select-container .returns-select-icon-left {
  z-index: 1;
}

.order-history-select-container .soft-select__menu {
  right: 0;
  left: auto;
  min-width: 190px;
  z-index: 300 !important;
}

.order-history-select-container .soft-select__control {
  height: 44px !important;
  border-radius: 22px !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  background-color: #ffffff !important;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
}

.order-history-select-container .soft-select__control--is-focused {
  border-color: #cbd5e1 !important;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08) !important;
}

.order-history-select-container .soft-select__value-container {
  padding-left: 44px !important;
  padding-right: 40px !important;
}

.order-history-select-container .soft-select__single-value {
  color: #334155 !important;
}

.order-history-select-container .soft-select-wrapper-I {
  border: none !important;
  margin-bottom: 0 !important;
}

.returns-filter-orders-select {
  height: 44px;
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: 22px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 44px;
  padding-right: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  outline: none;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;
}

.returns-filter-orders-select:hover {
  border-color: #cbd5e1;
  cursor: pointer;
}

.returns-select-icon-left {
  pointer-events: none;
  position: absolute;
  left: 16px;
  top: 50%;
  height: 16px;
  width: 16px;
  transform: translateY(-50%);
  color: #94a3b8;
}

.returns-select-icon-right {
  pointer-events: none;
  position: absolute;
  right: 16px;
  top: 50%;
  height: 16px;
  width: 16px;
  transform: translateY(-50%);
  color: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/ordersPage/OrdersPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB;;;;qDAImD;EACnD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB;;;;qDAImD;EACnD,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,uCAAuC;EACvC,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,iDAAiD;EACjD,sCAAsC;EACtC,UAAU;EACV,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB;;qBAEmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB;;sCAEoC;EACpC,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,4BAA4B;IAC5B,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,oDAAoD;EACpD,wCAAwC;AAC1C;;AAEA,wCAAwC;AACxC;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;EAC3C,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;EACZ,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C;;0BAEwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,qDAAqD;EACrD,oCAAoC;EACpC,wDAAwD;EACxD,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,qDAAqD;EACrD,oCAAoC;EACpC,wDAAwD;EACxD,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,aAAa;EACb;;8BAE4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,cAAc;AAChB","sourcesContent":[".orderAggsContainer {\n  padding-top: 64px;\n  padding-left: 8px;\n  padding-right: 8px;\n  width: 100%;\n  box-sizing: border-box;\n  height: 100vh;\n  /* margin-bottom: 70px; */\n}\n\n.orderAggsHeader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: space-between;\n  padding-right: 4px;\n}\n\n.aggTabsContainer {\n  display: flex;\n  align-items: center;\n  background-color: #fdfefe;\n  padding: 4px 4px;\n  border-radius: 50px;\n  font-size: 0.813rem;\n  font-weight: 500;\n  gap: 2px;\n  width: max-content;\n  box-shadow:\n    0 -1px 3px rgba(0, 0, 0, 0.04),\n    /* top shadow */ 0 -1px 2px rgba(0, 0, 0, 0.02),\n    /* soft top */ 0 1px 3px rgba(0, 0, 0, 0.04),\n    /* bottom shadow */ 0 1px 2px rgba(0, 0, 0, 0.02);\n  /* soft bottom */\n}\n\n.orderAggsHeaderRightContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.orderAggsHeader--kds {\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n\n.orderAggsHeader--kds > .aggTabsContainer,\n.orderAggsHeader--kds > .kds-tabs-navigation,\n.orderAggsHeaderRightContainer--kds > .prepstation-filter-wrapper,\n.orderAggsHeaderRightContainer--kds > .source-filter-wrapper {\n  flex-shrink: 0;\n}\n\n.orderAggsHeaderRightContainer--kds {\n  flex: 1 1 0;\n  min-width: 0;\n  gap: 6px;\n}\n\n.kds-tabs-navigation {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n}\n\n.kds-tabs-clip {\n  overflow: hidden;\n  flex: 0 0 auto;\n  transition: width 200ms ease;\n}\n\n.kds-tabs-content {\n  width: max-content;\n  padding: 2px;\n}\n\n.kds-tabs-content .aggsTabsInnerContainer {\n  white-space: nowrap;\n}\n\n.kds-tabs-content .aggsTabsInnerContainer[hidden] {\n  display: none;\n}\n\n.kds-tabs-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 28px;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 1px solid #dce4e9;\n  border-radius: 50%;\n  background: #fff;\n  color: #3f556b;\n  cursor: pointer;\n}\n\n.kds-tabs-toggle:hover {\n  background: #f1f5f9;\n}\n\n.kds-tabs-toggle:focus-visible {\n  outline: 2px solid #2a71ff;\n  outline-offset: 2px;\n}\n\n.kds-tabs-toggle svg {\n  transition: transform 200ms ease;\n}\n\n.kds-tabs-navigation.is-collapsed .kds-tabs-toggle svg {\n  transform: rotate(180deg);\n}\n\n.dark .kds-tabs-toggle {\n  background: #1e293b;\n  color: #cbd5e1;\n  border-color: #475569;\n}\n\n.dark .kds-tabs-toggle:hover {\n  background: #334155;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .kds-tabs-clip,\n  .kds-tabs-toggle svg {\n    transition: none;\n  }\n}\n\n@media (max-width: 900px) {\n  .orderAggsHeader--kds {\n    flex-wrap: wrap;\n  }\n  .orderAggsHeaderRightContainer--kds {\n    flex-basis: 100%;\n  }\n  .orderAggsHeader--kds.orderAggsHeader--tabs-collapsed {\n    flex-wrap: nowrap;\n  }\n  .orderAggsHeader--tabs-collapsed .orderAggsHeaderRightContainer--kds {\n    flex-basis: 0;\n  }\n}\n\n.aggsTabsInnerContainer {\n  padding: 6px 12px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #3f556b;\n}\n\n.tab-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.aggsTabsInnerContainer:hover {\n  background-color: var(--surface-g2);\n  color: var(--surface-black);\n  cursor: pointer;\n}\n\n.aggsTabsInnerContainer.active {\n  background-color: var(--surface-black);\n  color: var(--surface-white);\n}\n\n.orderAggsActiveTab {\n  margin-top: 8px;\n}\n\n.board-status-refresh-container {\n  background-color: #ffffff;\n  padding: 3px 2px;\n  border-radius: 12px;\n  box-shadow:\n    0 -1px 3px rgba(0, 0, 0, 0.04),\n    /* top shadow */ 0 -1px 2px rgba(0, 0, 0, 0.02),\n    /* soft top */ 0 1px 3px rgba(0, 0, 0, 0.04),\n    /* bottom shadow */ 0 1px 2px rgba(0, 0, 0, 0.02);\n  /* soft bottom */\n}\n\n.board-status-refresh-container:hover {\n  cursor: pointer;\n}\n\n.textAlignCorrection {\n  padding-top: 1px;\n}\n\n.pause-orders-btn-wrapper {\n  position: relative;\n  display: inline-flex;\n}\n\n.pause-orders-count-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 4px;\n  border-radius: 9999px;\n  background-color: #da4343;\n  color: #ffffff;\n  font-size: 0.65rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0 0 2px #ffffff;\n}\n\n/* Pause Orders Drawer Modal Styles */\n.pause-orders-drawer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background-color: #ffffff;\n  font-family: inherit;\n}\n\n/* Drawer Header */\n.drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 20px 24px;\n}\n\n.drawer-title {\n  font-size: 1.25rem;\n  /* text-xl */\n  font-weight: 600;\n  /* font-semibold */\n  letter-spacing: -0.025em;\n  /* tracking-tight */\n  color: #0f172a;\n  /* text-slate-900 */\n  margin: 0;\n}\n\n/* Close Button */\n.drawer-close-btn {\n  display: inline-flex;\n  height: 40px;\n  /* h-10 */\n  width: 40px;\n  /* w-10 */\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  /* rounded-full */\n  border: 1px solid #e2e8f0;\n  /* border-slate-200 */\n  background-color: transparent;\n  color: #64748b;\n  /* text-slate-500 */\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.drawer-close-btn:hover {\n  border-color: #cbd5e1;\n  /* border-slate-300 */\n  background-color: #f8fafc;\n  /* bg-slate-50 */\n  color: #0f172a;\n  /* text-slate-900 */\n}\n\n.drawer-close-btn svg {\n  width: 16px;\n  /* h-4 */\n  height: 16px;\n  /* w-4 */\n}\n\n/* Drawer Content */\n.drawer-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n/* Banner: Pause All Channels */\n.pause-all-banner {\n  border-radius: 28px;\n  border: 1px solid #ffedd5;\n  /* border-orange-100 */\n  background-color: rgba(254, 243, 199, 0.4);\n  /* bg-orange-50/60 styled beautifully */\n  padding: 16px;\n  box-shadow: 0 12px 30px rgba(249, 115, 22, 0.08);\n  margin-bottom: 20px;\n}\n\n.pause-all-flex {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.pause-all-title {\n  font-size: 0.875rem;\n  /* text-sm */\n  font-weight: 600;\n  /* font-semibold */\n  color: #0f172a;\n  /* text-slate-900 */\n  margin: 0;\n}\n\n.pause-all-subtitle {\n  margin-top: 4px;\n  font-size: 0.75rem;\n  /* text-xs */\n  color: #ea580c;\n  /* text-orange-600 */\n  margin-bottom: 0;\n}\n\n/* Toggle Switch Styles */\n.drawer-toggle-switch {\n  position: relative;\n  display: inline-flex;\n  height: 20px;\n  /* h-5 */\n  width: 36px;\n  /* w-9 */\n  flex-shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px;\n  /* rounded-full */\n  border: 2px solid transparent;\n  background-color: #cbd5e1;\n  /* gray bg when unchecked */\n  box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: background-color 0.2s ease;\n  padding: 0;\n  outline: none;\n}\n\n.drawer-toggle-switch[data-state=\"checked\"] {\n  background-color: #2a71ff;\n  /* bg-[#2A71FF] */\n}\n\n.drawer-toggle-switch:focus-visible {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  box-shadow:\n    0 0 0 2px #ffffff,\n    0 0 0 4px #2a71ff;\n}\n\n.drawer-toggle-switch:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.drawer-toggle-thumb {\n  pointer-events: none;\n  display: block;\n  height: 16px;\n  /* h-4 */\n  width: 16px;\n  /* w-4 */\n  border-radius: 9999px;\n  background-color: #ffffff;\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translateX(0);\n}\n\n.drawer-toggle-switch[data-state=\"checked\"] .drawer-toggle-thumb {\n  transform: translateX(16px);\n  /* translate-x-4 */\n}\n\n.platform-waiting-label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #ea580c;\n    background-color: rgba(254, 243, 199, 0.4);\n    border: 1.6px dotted #f97316;\n    padding: 2px 10px;\n    border-radius: 9999px;\n    white-space: nowrap;\n}\n\n/* Platforms List Container */\n.platforms-list-container {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  /* space-y-2 */\n}\n\n/* Platform Row */\n.platform-row-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-radius: 16px;\n  /* rounded-2xl */\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  /* border-slate-200/80 */\n  background-color: #ffffff;\n  padding: 12px 16px;\n  /* px-4 py-3 */\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);\n}\n\n.platform-info-flex {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  /* gap-3 */\n}\n\n/* Logo Box Container */\n.platform-logo-box {\n  display: flex;\n  height: 36px;\n  /* h-9 */\n  width: 36px;\n  /* w-9 */\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  /* rounded-xl */\n  background-color: #f8fafc;\n  /* bg-slate-50 */\n  box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.7);\n  /* ring-1 ring-inset ring-slate-200/70 */\n}\n\n/* Specific Platform Logo Badge Styles */\n.platform-icon-letter {\n  color: #ffffff;\n  padding: 4px;\n  border-radius: 6px;\n  /* rounded-md */\n  font-size: 10px;\n  /* text-[10px] */\n  font-weight: 700;\n  /* font-bold */\n  width: 24px;\n  /* w-6 */\n  height: 24px;\n  /* h-6 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.platform-zomato {\n  background-color: #dc2626;\n  /* bg-red-600 */\n}\n\n.platform-swiggy {\n  background-color: #f97316;\n  /* bg-orange-500 */\n}\n\n.platform-ubereats {\n  background-color: #16a34a;\n  /* bg-green-600 */\n}\n\n.platform-svg {\n  width: 24px;\n  /* w-6 */\n  height: 24px;\n  /* h-6 */\n}\n\n.platform-website {\n  color: #3b82f6;\n  /* text-blue-500 */\n}\n\n.platform-whatsapp {\n  color: #22c55e;\n  /* text-green-500 */\n}\n\n.platform-magicpin {\n  color: #64748b;\n  /* text-slate-500 */\n}\n\n.platform-label {\n  font-size: 15px;\n  /* text-[15px] */\n  font-weight: 600;\n  /* font-semibold */\n  color: #0f172a;\n  /* text-slate-900 */\n  cursor: pointer;\n}\n\n/* Drawer Sticky Footer */\n.drawer-footer {\n  position: sticky;\n  bottom: 0;\n  border-top: 1px solid #e2e8f0;\n  background-color: rgba(255, 255, 255, 0.95);\n  padding: 16px 24px;\n  /* px-6 py-4 */\n  backdrop-filter: blur(8px);\n  /* backdrop-blur-sm */\n  z-index: 10;\n}\n\n.drawer-footer-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  /* gap-3 */\n}\n\n/* Cancel Button */\n.drawer-btn-cancel {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  /* text-sm */\n  font-weight: 500;\n  /* font-medium */\n  transition: all 0.2s ease;\n  border: 1px solid #e2e8f0;\n  /* border-slate-200 */\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  border-radius: 9999px;\n  /* rounded-full */\n  height: 44px;\n  /* h-11 */\n  padding: 8px 20px;\n  /* px-5 py-2 */\n  color: #334155;\n  /* text-slate-700 */\n  background-color: #ffffff;\n  cursor: pointer;\n}\n\n.drawer-btn-cancel:hover {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n/* Save Button */\n.drawer-btn-save {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  /* text-sm */\n  font-weight: 500;\n  /* font-medium */\n  transition: all 0.2s ease;\n  border: 1px solid #2a71ff;\n  border-radius: 9999px;\n  /* rounded-full */\n  background-color: #2a71ff;\n  /* bg-[#2A71FF] */\n  padding: 8px 20px;\n  /* px-5 py-2 */\n  color: #ffffff;\n  /* text-white */\n  height: 44px;\n  /* h-11 */\n  cursor: pointer;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.drawer-btn-save:hover:not(:disabled) {\n  background-color: #1f63e8;\n  /* hover:bg-[#1F63E8] */\n  border-color: #1f63e8;\n}\n\n.drawer-btn-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Custom Returns Filter Header Styles */\n.returns-header-container {\n  display: flex;\n  min-width: 0;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 12px;\n}\n\n.returns-filters-wrapper {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 12px;\n}\n\n.returns-datepicker-wrapper {\n  position: relative;\n}\n\n.returns-datepicker-wrapper .react-datepicker-wrapper {\n  width: 166px;\n}\n\n.returns-datepicker-wrapper .react-datepicker__close-icon {\n  right: 0px;\n}\n\n.returns-filter-date-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  outline: none;\n  min-height: 36px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  height: 44px;\n  width: 174px;\n  justify-content: space-between;\n  border-radius: 22px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  padding-left: 16px;\n  padding-right: 30px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.returns-filter-date-btn:hover {\n  border-color: #cbd5e1;\n  background-color: #ffffff;\n  cursor: pointer;\n}\n\n.returns-filter-date-btn:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.returns-filter-date-btn-span {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.returns-select-container {\n  position: relative;\n  width: 170px;\n  flex-shrink: 0;\n}\n\n.returns-select-container .returns-select-icon-left {\n  z-index: 1;\n}\n\n.returns-select-container .soft-select__menu {\n  right: 0;\n  left: auto;\n  min-width: 190px;\n  z-index: 300 !important;\n}\n\n.returns-select-container .soft-select__control {\n  height: 44px !important;\n  border-radius: 22px !important;\n  border: 1px solid rgba(226, 232, 240, 0.8) !important;\n  background-color: #ffffff !important;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08) !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  cursor: pointer !important;\n}\n\n.returns-select-container .soft-select__control--is-focused {\n  border-color: #cbd5e1 !important;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08) !important;\n}\n\n.returns-select-container .soft-select__value-container {\n  padding-left: 44px !important;\n  padding-right: 40px !important;\n}\n\n.returns-select-container .soft-select__single-value {\n  color: #334155 !important;\n}\n\n.returns-select-container .soft-select-wrapper-I {\n  border: none !important;\n  margin-bottom: 0 !important;\n}\n\n.order-history-select-container {\n  position: relative;\n  width: 170px;\n  flex-shrink: 0;\n}\n\n.order-history-select-container .returns-select-icon-left {\n  z-index: 1;\n}\n\n.order-history-select-container .soft-select__menu {\n  right: 0;\n  left: auto;\n  min-width: 190px;\n  z-index: 300 !important;\n}\n\n.order-history-select-container .soft-select__control {\n  height: 44px !important;\n  border-radius: 22px !important;\n  border: 1px solid rgba(226, 232, 240, 0.8) !important;\n  background-color: #ffffff !important;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08) !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  cursor: pointer !important;\n}\n\n.order-history-select-container .soft-select__control--is-focused {\n  border-color: #cbd5e1 !important;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08) !important;\n}\n\n.order-history-select-container .soft-select__value-container {\n  padding-left: 44px !important;\n  padding-right: 40px !important;\n}\n\n.order-history-select-container .soft-select__single-value {\n  color: #334155 !important;\n}\n\n.order-history-select-container .soft-select-wrapper-I {\n  border: none !important;\n  margin-bottom: 0 !important;\n}\n\n.returns-filter-orders-select {\n  height: 44px;\n  width: 100%;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border-radius: 22px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-left: 44px;\n  padding-right: 40px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  outline: none;\n  transition:\n    border-color 0.2s ease,\n    background-color 0.2s ease;\n}\n\n.returns-filter-orders-select:hover {\n  border-color: #cbd5e1;\n  cursor: pointer;\n}\n\n.returns-select-icon-left {\n  pointer-events: none;\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  height: 16px;\n  width: 16px;\n  transform: translateY(-50%);\n  color: #94a3b8;\n}\n\n.returns-select-icon-right {\n  pointer-events: none;\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  height: 16px;\n  width: 16px;\n  transform: translateY(-50%);\n  color: #94a3b8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
